import { Injectable } from '@angular/core';
import { WebSocketService } from '@services/web-socket.service';
import { NotificationsService } from '@services/notifications.service';
import { NotificationMessageIcon } from '@app/framework/notification-sidebar/notification-sidebar.component';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { TranslationService } from '@services/translation.service';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GradeExportService {
  /*Array of export ids initiated form this instance of Scaffold*/
  exporting = [];
  subscription: Subscription;
  constructor(private webSocketService: WebSocketService, private notifications: NotificationsService, private httpClient: HttpClient, private translationService: TranslationService) { }

  init(): void {
    console.log('Subscribe: grade-export');
    if (!this.subscription) {
      this.subscription = this.webSocketService.subscribeToMessages('grade-export').subscribe(message => {
        console.log(message);
        this.addNotification(message);
        if (message.url) {
          Array.isArray(message.url) ? 
          message.url.forEach(url => this.completeRequest(message, url)) :
          this.completeRequest(message, message.url);
        }
      });
    }
  }
  /**
   * Add an export to the exporting array
   * @param requestId 
   */
  exportStarted(requestId){
    this.exporting.push(requestId);
    this.addNotification({
      requestId: requestId,
      progress: 0,
      details: this.translationService.getTranslatedContent('export_started', 'Export Started'),
      status: this.translationService.getTranslatedContent('export_started', 'Export Started'),
    });
  }
  /**
 * Add an export notification to the user notification sidebar
 * @param data object containing data about an export
 */
  addNotification(data) {
    console.log('addNotification', data);
    if (this.exporting.includes(data.requestId)) {
      this.notifications.addUserNotification(
        {
          icon: NotificationMessageIcon.fileZip,
          progress: data.progress,
          text: data.details,
          status: (data.progress || 0) + '%',
          shouldForceOpen: true,
        },
        data.requestId
      );
    }
  }

  /**
   * Complete download of export after recieving the socket notification that it has completed
   * @param data
   */
  completeRequest(data, url?) {
    console.log('completeRequest', data, url);
    let signedUrl = url || data.url;
    if (this.exporting.includes(data.requestId)) {
      this.httpClient
        .get(signedUrl, {
          responseType: "blob",
          reportProgress: true,
          observe: 'events'
        })
        .subscribe(
          (res) => {
            console.log('res', res);
            if (res.type === HttpEventType.DownloadProgress) {
              const percentDone = Math.round(100 * res.loaded / res.total);
              this.notifications.addUserNotification(
                {
                  icon: NotificationMessageIcon.fileZip,
                  text: this.translationService.getTranslatedContent('downloading_export', 'Downloading export'),
                  progress: percentDone,
                  status: this.translationService.getTranslatedContent('downloading', 'Downloading'),
                },
                data.requestId
              );
            }
            if (res.type === HttpEventType.Response) {
              const blob = new Blob([res.body], {
                type: data.type,
              });
              const a = document.createElement("a");
              const url = window.URL.createObjectURL(blob);
              a.href = url;
              a.download = data.title;
              a.click();
              window.URL.revokeObjectURL(url);
              this.notifications.addUserNotification(
                {
                  icon: NotificationMessageIcon.checkmark,
                  text: this.translationService.getTranslatedContent('export_downloaded', 'Export Downloaded'),
                  progress: 100,
                  status: this.translationService.getTranslatedContent('download_complete', 'Download Complete'),
                },
                data.requestId
              );
            }
          },
          (err) => {
          }
        );
    }
  }


}
